var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#000",
    opacity: 0,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D8D8D8",
    opacity: 0,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M21.4378911,10.559957 C21.2246619,10.346681 20.8780278,10.346681 20.6647986,10.559957 L15.9989065,15.2268743 L11.3330144,10.559957 C11.1197852,10.346681 10.7731511,10.346681 10.5599219,10.559957 C10.3466927,10.7732331 10.3466927,11.1199434 10.5599219,11.3332194 L15.225814,16.0001367 L10.5599219,20.667054 C10.3466927,20.8803301 10.3466927,21.2270404 10.5599219,21.4403164 C10.6670832,21.5475013 10.8070491,21.6 10.9470149,21.6 C11.0869807,21.6 11.2269465,21.5464076 11.3341079,21.4403164 L16,16.7733991 L20.6658921,21.4403164 C20.7730535,21.5475013 20.9130193,21.6 21.0529851,21.6 C21.1929509,21.6 21.3329168,21.5464076 21.4400781,21.4403164 C21.6533073,21.2270404 21.6533073,20.8803301 21.4400781,20.667054 L16.774186,16.0001367 L21.4400781,11.3332194 C21.6522138,11.1199434 21.6522138,10.7732331 21.4378911,10.559957 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.edd4a9e05137fb837a7addd853e9099f.svg";
export { ForwardRef as ReactComponent };